import { useMemo } from 'react';

import { TabOption } from '@/components/chariot-ui';
import {
  ASSET_DRAWER_TAB_LABELS,
  ASSET_DRAWER_TAB_OPTIONS,
  ASSET_DRAWER_TABS,
} from '@/sections/asset/constants';
import { Asset } from '@/types';

export function useAssetTabs(asset?: Asset): TabOption[] {
  return useMemo(() => {
    const baseTabs = [...ASSET_DRAWER_TAB_OPTIONS];

    const hasAffiliationData = asset?.history?.some(
      item => item.filePath && item.affiliationVerdict
    );

    if (hasAffiliationData) {
      const notesIndex = baseTabs.findIndex(
        tab => tab.value === ASSET_DRAWER_TABS.NOTES
      );
      baseTabs.splice(notesIndex >= 0 ? notesIndex : baseTabs.length, 0, {
        label: ASSET_DRAWER_TAB_LABELS[ASSET_DRAWER_TABS.AFFILIATION],
        value: ASSET_DRAWER_TABS.AFFILIATION,
      });
    }

    return baseTabs;
  }, [asset]);
}
